import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  GetDelovodniDokumentTableQuery,
  GetRacuneZaPlacanjeQuery,
  PaginatedResultOfRacunZaPlacanjeDto,
  RacuniClient
} from '@kodit/core/data-api';
import { TableConfig } from '@kodit/core/shared-ui';
import { finalize } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ConfigService } from '@kodit/core/services';

@Component({
  selector: 'kodit-placanja-table',
  templateUrl: './placanja-table.component.html',
  styleUrls: ['./placanja-table.component.scss'],
})
export class PlacanjaTableComponent implements OnInit, OnDestroy {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Props */
  paginatedData!: PaginatedResultOfRacunZaPlacanjeDto;
  filters!: GetDelovodniDokumentTableQuery;
  private _skipFirst = 0;
  numberOfRowsDisplayed = 0;
  private _isBusy = false;
  isFirstLoad = true;
  isEmpty = false;

  /** Configurations */
  tableConfig!: TableConfig;

  /** I/O */
  @Input() samoNeplaceni: boolean | undefined;
  @Input() isKodit: boolean | undefined;

  constructor(
    private _client: RacuniClient,
    private _configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.setTableConfig().then();
  }

  async setTableConfig(): Promise<void> {
    this.tableConfig = new TableConfig({
      tableHeader: this.samoNeplaceni
        ? this.isKodit
          ? 'Neizmirene fakture Kodit'
          : 'Neizmirene fakture ekompanijaAlfa'
        : this.isKodit
          ? 'Plaćanja Kodit'
          : 'Plaćanja ekompanijaAlfa',
      isLazy: true,
      lazyCallbackFunction: (event) => {
        if (!this.isFirstLoad) {
          this._skipFirst = event.first!;
          this.numberOfRowsDisplayed = event.rows!;
        }
        if (this.isFirstLoad) {
          this.isFirstLoad = false;
        }
        this._load();
      },
      columns: [
        {
          field: 'broj',
          header: 'Broj fakture',
          type: 'text',
        },
        {
          field: 'datumValute',
          header: 'Datum',
          type: 'text',
        },
        {
          field: 'iznosStr',
          header: 'Iznos',
          type: 'text',
        },
        {
          field: 'status',
          header: 'Status',
          type: 'text',
        },
      ],
    });
  }
  private _load() {
    if (this._isBusy) {
      return;
    }

    this._configService.setIsBusy = true;
    this._isBusy = true;

    if (!this.filters) {
      this.filters = new GetRacuneZaPlacanjeQuery({
        pageNumber: this._skipFirst,
        pageSize: this.numberOfRowsDisplayed,
        samoNeplaceni: this.samoNeplaceni,
        fromKodit: this.isKodit
      });
    }

    this.filters.pageNumber = this._skipFirst;
    this.filters.pageSize = this.numberOfRowsDisplayed;

    this._subs.add(
      this._client
        .getRacuneZaPlacanje(this.filters)
        .pipe(
          finalize(() => {
            this._configService.setIsBusy = false;
            this._isBusy = false;
          })
        )
        .subscribe((res) => {
          if (res.succeeded) {
            this.paginatedData = res;
            this.isEmpty = res.data.length === 0;
          }
        })
    );
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
